import {Box, Button, LinearProgress} from '@mui/material';
import {styled} from '@mui/material/styles';

import Input from 'components/input/Input';

export const StyledProPointsSuggestionContainer = styled(Box)<{isReactNativeView?: boolean}>(
  ({theme, bgcolor, isReactNativeView}) => ({
    margin: isReactNativeView ? theme.spacing(1) : theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    backgroundColor: `${bgcolor || theme.palette.common.mds_global_background_yellow}`,
    marginTop: isReactNativeView ? theme.spacing(2) : theme.spacing(1),
    marginBottom: isReactNativeView ? theme.spacing(2) : theme.spacing(1)
  })
);

export const StyledSectionHeader = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1.5)
}));

export const StyledSectionContentContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.shadows[1],
  marginBottom: theme.spacing(2)
}));

export const StyledSeeMoreBtn = styled(Button)(() => ({
  display: 'flex',
  alignItems: 'center'
}));

export const StyledActivateNowBtn = styled(Button)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${theme.spacing(0.75)} ${theme.spacing(1.5)}`,
  borderRadius: theme.spacing(2),
  border: `${theme.spacing(0.2)} solid ${theme.palette.primary.main}`
}));

export const StyledFooterContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(0.5),
  gap: theme.spacing(1.5)
}));

export const StyledProgressBox = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  ' .progressBar-coin': {
    zIndex: 1,
    position: 'absolute',
    top: theme.spacing(-0.75),
    transform: 'translateX(-50%)'
  }
}));

export const StyledProgressBar = styled(LinearProgress)(({theme}) => ({
  backgroundColor: '#F4F4F4',
  height: theme.spacing(1),
  marginTop: theme.spacing(1),
  padding: theme.spacing(0.25, 0),
  borderRadius: theme.spacing(6),
  ' .MuiLinearProgress-bar': {
    backgroundColor: '#FFCF00'
  }
}));

export const RedeemPromotionInput = styled(Input)(({theme}) => ({
  // height: theme.spacing(5),
  borderWidth: theme.spacing(0),
  '&:focused': {
    borderWidth: '0',
    outline: 'none'
  }
}));

export const RedeemPromotionBtn = styled(Button)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontWeight: theme.typography.fontWeightBold,
  backgroundColor: theme.palette.common.mds_global_color_red_25,
  borderRadius: theme.spacing(4.75),
  height: theme.spacing(4.75),
  width: theme.spacing(10.5),
  textAlign: 'center',
  alignSelf: 'center',
  '&:disabled': {
    color: theme.palette.grey[300],
    backgroundColor: theme.palette.grey[50]
  }
}));

export const StyledRibbonBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifySelf: 'flex-start',
  gap: theme.spacing(1),
  padding: theme.spacing(0.2, 0.5),
  borderRadius: theme.spacing(0.5),
  backgroundColor: '#ECDFFF'
}));
